import React, { useState } from 'react';
import { Box, Container } from '@mui/material';
import { TodayView } from '../components/TodayView';
import { sampleTodayPlan } from '../data/sampleTodayData';
import { TodayPlan } from '../types/today';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

function TodayPage() {
  useDocumentTitle('Today');

  const [plan, setPlan] = useState<TodayPlan>(sampleTodayPlan);

  const handleTaskToggle = (taskId: string) => {
    setPlan((prevPlan) => ({
      ...prevPlan,
      sections: prevPlan.sections.map((section) => ({
        ...section,
        tasks: section.tasks.map((task) =>
          task.id === taskId
            ? { ...task, isCompleted: !task.isCompleted }
            : task
        ),
      })),
    }));
  };

  const handleAddTask = (sectionId: string) => {
    console.log('Add task to section:', sectionId);
    // TODO: Implement add task dialog
  };

  return (
    <Box sx={{ flex: 1, bgcolor: 'background.default' }}>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <TodayView
          plan={plan}
          onTaskToggle={handleTaskToggle}
          onAddTask={handleAddTask}
        />
      </Container>
    </Box>
  );
}

export default TodayPage;
